import React from 'react';

export const therapyTasksConfig = [
  {
    auth: ['user'],
    routes: [
      {
        path: [
          '/therapy-tasks',
          '/therapy-tasks/signposting',
          '/therapy-tasks/leaflet',
          '/therapy-tasks/physical-parameters',
        ],
        component: React.lazy(() => import('./AppTherapyNew')),
      },
    ],
  },
];

